import { Box, Stack } from '@mui/material';
import DarkModeToggle from './DarkModeToggle';
import ThemeSelector from './ThemeSelector';

/**
 * Utseende-flik: Dark mode toggle + Tema-väljare i en expanderbar sektion.
 */
const AppearanceSettings = () => (
  <Stack spacing={1} sx={{ p: 1 }}>
    <DarkModeToggle id="darkMode" title="Dark mode" />
    <Box sx={{ mt: 1 }}>
      <ThemeSelector id="themeSelector" title="" />
    </Box>
  </Stack>
);

export default AppearanceSettings;
